import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import adminsEN from './en/admins.json';
import authEN from './en/auth.json';
import commonEN from './en/common.json';
import documentsEN from './en/documents.json';
import logsEN from './en/logs.json';
import orderEN from './en/order.json';
import pricesEN from './en/prices.json';
import profileEN from './en/profile.json';
import propertyEN from './en/property.json';
import settingsEN from './en/settings.json';
import usersEN from './en/users.json';
import viewingEN from './en/viewing.json';
import biddingEN from './en/bidding.json';

const resources = {
  en: {
    common: commonEN,
    auth: authEN,
    admins: adminsEN,
    order: orderEN,
    settings: settingsEN,
    users: usersEN,
    profile: profileEN,
    prices: pricesEN,
    property: propertyEN,
    documents: documentsEN,
    logs: logsEN,
    viewing: viewingEN,
    bidding: biddingEN,
  },
};

i18n.use(initReactI18next).init({
  resources,
  lng: 'en',
  defaultNS: 'common',
  interpolation: {
    escapeValue: false,
  },
});

export default i18n;
